/**
 * [CALMONT] Video Stories — Carousel + Modal
 * Portiert von glør (glor-video-stories.js).
 *
 * Änderungen gegenüber dem Original:
 *  - Echtes Add-to-Cart über Impacts cart/add.js + variant:add/cart:change Events
 *    (Original setzte nur window.location.href — data-variant-id wurde nie gelesen)
 *  - preloadCache mit LRU-Limit (Original hängte unbegrenzt <video> ins DOM)
 *  - navigate() nutzt currentStories[currentIndex]._atcText statt [0]
 *  - Pfeil-Scroll orientiert sich an der echten Kachelbreite statt an fixen 138px
 *  - Tastaturbedienung der Kacheln (Enter/Space)
 */
(function () {
  'use strict';

  /* ── Video Preload Cache (nur für Modal) ── */
  var preloadCache = {};
  var preloadOrder = [];
  var PRELOAD_MAX = 4;

  function preloadVideoSrc(src) {
    if (!src || preloadCache[src]) return;

    /* Ältesten Eintrag entsorgen — sonst wächst das DOM unbegrenzt */
    while (preloadOrder.length >= PRELOAD_MAX) {
      var oldest = preloadOrder.shift();
      var el = preloadCache[oldest];
      if (el && el.parentNode) el.parentNode.removeChild(el);
      delete preloadCache[oldest];
    }

    var v = document.createElement('video');
    v.preload = 'auto';
    v.muted = true;
    v.src = src;
    v.style.cssText = 'position:fixed;opacity:0;pointer-events:none;width:1px;height:1px;top:-9999px;left:-9999px';
    document.body.appendChild(v);
    preloadCache[src] = v;
    preloadOrder.push(src);
  }

  /* ── Singleton Modal ── */
  var modal = null;
  var currentStories = [];
  var currentIndex = 0;
  var lastFocused = null;

  /* Ton-Wunsch überdauert das Schließen des Modals — aber bewusst nicht die Session,
     damit niemand beim nächsten Besuch unerwartet beschallt wird. */
  var soundOn = false;

  function setSound(on) {
    soundOn = on;
    if (!modal) return;

    var vid = modal.querySelector('.calmont-modal-video');
    var btn = modal.querySelector('[data-modal-sound]');

    vid.muted = !on;
    /* Safari braucht nach dem Unmute teils einen erneuten play()-Aufruf */
    if (on) vid.play().catch(function () {});

    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.setAttribute('aria-label', on ? 'Ton ausschalten' : 'Ton einschalten');
    btn.classList.toggle('is-on', on);
  }

  function getModal() {
    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'calmont-stories-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML = [
      '<div class="calmont-modal-backdrop" data-modal-close></div>',
      '<div class="calmont-modal-content">',
        '<button class="calmont-modal-close" data-modal-close type="button" aria-label="Schließen">',
          '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">',
            '<path d="M1 1l14 14M15 1L1 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
          '</svg>',
        '</button>',
        '<button class="calmont-modal-nav calmont-modal-prev" data-modal-prev type="button" aria-label="Vorheriges">',
          '<svg width="10" height="18" viewBox="0 0 10 18" fill="none" aria-hidden="true">',
            '<path d="M7.797 16.664.648 9.204A1.071 1.071 0 0 1 .375 8.5c0-.195.078-.43.234-.625L7.758.415a.932.932 0 0 1 1.328-.04c.39.352.39.938.039 1.328L2.602 8.5l6.562 6.875a.932.932 0 0 1-.039 1.328.932.932 0 0 1-1.328-.039Z" fill="currentColor"/>',
          '</svg>',
        '</button>',
        '<video class="calmont-modal-video" playsinline loop muted preload="auto"></video>',
        '<button class="calmont-modal-sound" data-modal-sound type="button" aria-label="Ton einschalten" aria-pressed="false" hidden>',
          '<svg class="calmont-icon-muted" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">',
            '<path d="M11 5 6 9H3v6h3l5 4V5Z" fill="currentColor"/>',
            '<path d="m16 9 5 6m0-6-5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
          '</svg>',
          '<svg class="calmont-icon-unmuted" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">',
            '<path d="M11 5 6 9H3v6h3l5 4V5Z" fill="currentColor"/>',
            '<path d="M15.5 8.5a5 5 0 0 1 0 7M18.5 5.5a9 9 0 0 1 0 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>',
          '</svg>',
        '</button>',
        '<button class="calmont-modal-nav calmont-modal-next" data-modal-next type="button" aria-label="Nächstes">',
          '<svg width="10" height="18" viewBox="0 0 10 18" fill="none" aria-hidden="true">',
            '<path d="M7.797 16.664.648 9.204A1.071 1.071 0 0 1 .375 8.5c0-.195.078-.43.234-.625L7.758.415a.932.932 0 0 1 1.328-.04c.39.352.39.938.039 1.328L2.602 8.5l6.562 6.875a.932.932 0 0 1-.039 1.328.932.932 0 0 1-1.328-.039Z" fill="currentColor"/>',
          '</svg>',
        '</button>',
        '<div class="calmont-modal-product-bar">',
          '<a class="calmont-modal-product-link" href="#">',
            '<img class="calmont-modal-product-img" src="" alt="" loading="lazy" width="48" height="48">',
            '<div>',
              '<p class="calmont-modal-product-title"></p>',
              '<p class="calmont-modal-product-price"></p>',
            '</div>',
          '</a>',
          '<button class="calmont-modal-atc" type="button">Zum Produkt</button>',
        '</div>',
      '</div>'
    ].join('');
    document.body.appendChild(modal);

    modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.stopPropagation();
        closeModal();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (!modal || !modal.classList.contains('is-open')) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowLeft') navigate(-1);
      if (e.key === 'ArrowRight') navigate(1);
    });

    modal.querySelector('[data-modal-sound]').addEventListener('click', function (e) {
      e.stopPropagation();
      setSound(!soundOn);
    });

    modal.querySelector('[data-modal-prev]').addEventListener('click', function () { navigate(-1); });
    modal.querySelector('[data-modal-next]').addEventListener('click', function () { navigate(1); });
    modal.querySelector('.calmont-modal-atc').addEventListener('click', handleAtc);

    return modal;
  }

  function openModal(stories, index) {
    currentStories = stories;
    currentIndex = index;
    lastFocused = document.activeElement;
    getModal();
    loadStory(index);
    modal.classList.add('is-open');
    document.body.classList.add('calmont-modal-open');
    modal.querySelector('.calmont-modal-close').focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('calmont-modal-open');
    var v = modal.querySelector('.calmont-modal-video');
    v.pause();
    v.removeAttribute('src');
    v.load();
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function navigate(dir) {
    var next = currentIndex + dir;
    if (next < 0 || next >= currentStories.length) return;
    currentIndex = next;
    loadStory(currentIndex);
  }

  function loadStory(index) {
    var s = currentStories[index];
    var m = getModal();
    var vid = m.querySelector('.calmont-modal-video');

    /* Ton-Button nur zeigen, wenn die Section es erlaubt */
    var soundBtn = m.querySelector('[data-modal-sound]');
    soundBtn.hidden = s.soundEnabled !== 'true';

    /* Video: src direkt setzen ohne load() — Browser nutzt Cache wenn verfügbar */
    vid.poster = s.poster || '';
    if (s.videoSrc) {
      vid.src = s.videoSrc;
      /* Ton-Wunsch auf das neue Video übertragen. Stumm starten wäre sicherer,
         aber der Nutzer hat den Ton bewusst angefordert — beim Weiterblättern
         soll er anbleiben. */
      vid.muted = !(soundOn && s.soundEnabled === 'true');
      vid.play().catch(function () {
        /* Ton blockiert (z.B. iOS Low Power Mode) → stumm nachziehen statt Standbild */
        if (!vid.muted) {
          setSound(false);
          vid.play().catch(function () {});
        }
      });
    }

    if (s.soundEnabled === 'true') setSound(soundOn);

    /* Benachbarte Stories vorab laden */
    [-1, 1].forEach(function (offset) {
      var adj = currentStories[index + offset];
      if (adj && adj.videoSrc) preloadVideoSrc(adj.videoSrc);
    });

    /* Product bar */
    var bar = m.querySelector('.calmont-modal-product-bar');
    var hasProduct = !!(s.productUrl || s.productTitle);
    bar.style.display = hasProduct ? '' : 'none';

    if (hasProduct) {
      m.querySelector('.calmont-modal-product-link').href = s.productUrl || '#';

      var img = m.querySelector('.calmont-modal-product-img');
      if (s.productImg) {
        img.src = s.productImg;
        img.alt = s.productTitle || '';
        img.style.display = '';
      } else {
        img.removeAttribute('src');
        img.style.display = 'none';
      }

      m.querySelector('.calmont-modal-product-title').textContent = s.productTitle || '';
      m.querySelector('.calmont-modal-product-price').textContent = s.productPrice || '';

      var atcBtn = m.querySelector('.calmont-modal-atc');
      atcBtn.dataset.productUrl = s.productUrl || '';
      atcBtn.dataset.variantId = s.variantId || '';
      atcBtn.dataset.mode = s.atcMode || 'link';
      atcBtn.textContent = s.atcText || 'Zum Produkt';
      atcBtn.disabled = false;

      /* Cart-Modus ohne Variante oder ausverkauft → auf Link zurückfallen */
      if (atcBtn.dataset.mode === 'cart' && (!s.variantId || s.productAvailable === 'false')) {
        atcBtn.dataset.mode = 'link';
      }
    }

    m.querySelector('[data-modal-prev]').hidden = index === 0;
    m.querySelector('[data-modal-next]').hidden = index === currentStories.length - 1;
  }

  function handleAtc() {
    var btn = modal.querySelector('.calmont-modal-atc');

    if (btn.dataset.mode !== 'cart' || !btn.dataset.variantId) {
      if (btn.dataset.productUrl) window.location.href = btn.dataset.productUrl;
      return;
    }

    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    /* Impact bündelt Sections mit — sonst aktualisiert sich der Drawer nicht */
    var sectionsToBundle = ['variant-added'];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    var formData = new FormData();
    formData.set('id', btn.dataset.variantId);
    formData.set('quantity', '1');
    formData.set('sections', sectionsToBundle.join(','));
    formData.set('sections_url', Shopify.routes.root + 'variants/' + btn.dataset.variantId);

    fetch(Shopify.routes.root + 'cart/add.js', {
      body: formData,
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        return response.json().then(function (json) {
          return { ok: response.ok, json: json };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          btn.textContent = res.json.description || res.json.message || 'Nicht verfügbar';
          /* Wie Impact: Drawer resynchronisieren, sonst zeigt er einen Stand der nie ankam */
          document.documentElement.dispatchEvent(new CustomEvent('cart:error', {
            bubbles: true,
            detail: { error: res.json.description || res.json.message }
          }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2500);
          return;
        }

        var cartType = (window.themeVariables && window.themeVariables.settings.cartType) || 'drawer';
        var pageType = (window.themeVariables && window.themeVariables.settings.pageType) || '';

        if (cartType === 'page' || pageType === 'cart') {
          window.location.href = Shopify.routes.root + 'cart';
          return;
        }

        return fetch(Shopify.routes.root + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cartContent) {
            cartContent.sections = res.json.sections;
            var items = res.json.hasOwnProperty('items') ? res.json.items : [res.json];

            closeModal();

            document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
              bubbles: true,
              detail: { items: items, cart: cartContent }
            }));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'variant:add', cart: cartContent }
            }));

            btn.textContent = originalText;
            btn.disabled = false;
          });
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      });
  }

  /* ── Per-carousel init ── */
  function initCarousel(wrap) {
    if (wrap.dataset.calmontInit) return;
    wrap.dataset.calmontInit = '1';

    var tiles = wrap.querySelector('[data-calmont-tiles]');
    var btnPrev = wrap.querySelector('[data-calmont-prev]');
    var btnNext = wrap.querySelector('[data-calmont-next]');
    var atcText = wrap.dataset.atcText || 'Zum Produkt';
    var atcMode = wrap.dataset.atcMode || 'link';
    var soundEnabled = wrap.dataset.sound || 'false';
    if (!tiles) return;

    var tileEls = Array.prototype.slice.call(tiles.querySelectorAll('[data-calmont-tile]'));
    if (!tileEls.length) return;

    var stories = tileEls.map(function (tile) {
      return {
        videoSrc: tile.dataset.videoSrc || '',
        poster: tile.dataset.poster || '',
        productUrl: tile.dataset.productUrl || '',
        productTitle: tile.dataset.productTitle || '',
        productPrice: tile.dataset.productPrice || '',
        productImg: tile.dataset.productImg || '',
        productAvailable: tile.dataset.productAvailable || '',
        variantId: tile.dataset.variantId || '',
        atcText: atcText,
        atcMode: atcMode,
        soundEnabled: soundEnabled
      };
    });

    tileEls.forEach(function (tile, i) {
      var preloadTile = function () {
        if (stories[i] && stories[i].videoSrc) preloadVideoSrc(stories[i].videoSrc);
      };
      tile.addEventListener('mouseenter', preloadTile);
      tile.addEventListener('touchstart', preloadTile, { passive: true });
      tile.addEventListener('click', function () { openModal(stories, i); });
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openModal(stories, i);
        }
      });
    });

    /* Thumbnail-Videos: nur abspielen wenn sichtbar */
    if (typeof IntersectionObserver !== 'undefined') {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (v.dataset.src && !v.src) v.src = v.dataset.src;
            v.play().catch(function () {});
          } else {
            v.pause();
          }
        });
      }, { threshold: 0.5 });

      tiles.querySelectorAll('video[data-src]').forEach(function (v) { observer.observe(v); });
    }

    /* Arrow visibility */
    function updateArrows() {
      if (!btnPrev || !btnNext) return;
      var atStart = tiles.scrollLeft <= 8;
      var atEnd = tiles.scrollLeft + tiles.clientWidth >= tiles.scrollWidth - 8;
      var noOverflow = tiles.scrollWidth <= tiles.clientWidth + 8;
      btnPrev.setAttribute('data-hidden', atStart || noOverflow ? 'true' : 'false');
      btnNext.setAttribute('data-hidden', atEnd || noOverflow ? 'true' : 'false');
    }

    tiles.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    /* Scrollweite aus der echten Kachelbreite ableiten */
    function step() {
      var first = tileEls[0];
      if (!first) return 260;
      var gap = parseFloat(getComputedStyle(tiles).columnGap) || 10;
      return (first.getBoundingClientRect().width + gap) * 2;
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { tiles.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (btnNext) btnNext.addEventListener('click', function () { tiles.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  function initAll() {
    document.querySelectorAll('[data-calmont-stories]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('[data-calmont-stories]').forEach(initCarousel);
  });

  /**
   * Impact ersetzt bei productChange (Sibling-Swatches / Produkt-Varianten) den kompletten
   * product-info-Teilbaum via replaceWith. Das neue Markup ist uninitialisiert und es gibt
   * kein Event dafür — daher beobachten wir das DOM und initialisieren neu.
   */
  if (typeof MutationObserver !== 'undefined') {
    var reinitScheduled = false;

    var domObserver = new MutationObserver(function (mutations) {
      if (reinitScheduled) return;

      var relevant = mutations.some(function (m) {
        return Array.prototype.some.call(m.addedNodes, function (node) {
          if (node.nodeType !== 1) return false;
          return (
            (node.hasAttribute && node.hasAttribute('data-calmont-stories')) ||
            (node.querySelector && node.querySelector('[data-calmont-stories]'))
          );
        });
      });

      if (!relevant) return;

      reinitScheduled = true;
      requestAnimationFrame(function () {
        reinitScheduled = false;
        initAll();
      });
    });

    domObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
